// extracted by css-extract-rspack-plugin
export default {"smartLink":"tz4xq","icon":"KgyZt","smartLinkInner":"A916V"};